/* eslint-disable react/react-in-jsx-scope */
// import
// import Dashboard from "views/Dashboard/Dashboard";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import Logout from "views/Auth/Logout.js";

import {
  HomeIcon,
  DocumentIcon,
  PersonIcon,
  RocketIcon,
  StatsIcon,
  LogoutIcon
} from "components/Icons/Icons";
import PatientDetails from "views/Dashboard/Dashboard/Companies/Biom/PatientDetails";
import PatientsList from "views/Dashboard/Dashboard/Companies/Biom/PatientsList";
import BiomDashboard from "views/Dashboard/Dashboard/Companies/Biom/BiomDashboard";
import ImportData from "views/Dashboard/Dashboard/Companies/Biom/ImportData";

const getDashRoutes = () => {
  return [
    {
      path: "/dashboard",
      name: "Analytics",
      icon: <HomeIcon color="inherit" />,
      component: BiomDashboard,
      layout: "/admin",
      showSidebar: true,
    },
    {
      path: "/patients-list",
      name: "Patients List",
      icon: <PersonIcon color="inherit" />,
      component: PatientsList,
      layout: "/admin",
      showSidebar: true,
    },
    {
      path: "/import-data",
      name: "Import Data",
      icon: <RocketIcon color="inherit" />,
      component: ImportData,
      layout: "/admin",
      showSidebar: true,
    },
    {
      path: "/patient-details/:identifier?",
      name: "Patient Details",
      icon: <StatsIcon color="inherit" />,
      component: PatientDetails,
      layout: "/admin",
      showSidebar: false,
    },
    {
      path: "/logout",
      name: "Logout",
      icon: <LogoutIcon color="inherit" />,
      component: Logout,
      layout: "/admin",
      showSidebar: true,
    },
    {
      category: "account",
      state: "pageCollapse",
      views: [
        {
          path: "/signin",
          name: "Sign In",
          icon: <DocumentIcon color="inherit" />,
          component: SignIn,
          layout: "/auth",
          showSidebar: false,
        },
        {
          path: "/signup",
          name: "Sign Up",
          icon: <DocumentIcon color="inherit" />,
          component: SignUp,
          layout: "/auth",
          showSidebar: false,
        },
      ],
    },
  ];
};

export default getDashRoutes;
